import React from 'react';

export default ({ location, path, tree, icon, label }) => {
  const rotaAtiva =
    location.includes(path.substring(1, path.length)) ||
    (location === '/' && path === '#/dashboards');

  return (
    <li className={rotaAtiva ? 'active' : ''}>
      <a href={path}>
        {tree
          ? icon && <i className={`fa fa-${icon}`} style={{ marginLeft: -23, color: '#0077FF' }} />
          : icon && <i className={`fa fa-${icon}`} style={{ color: '#0077FF' }} />}
        {tree ? label : <span className="nav-label">{label}</span>}
      </a>
    </li>
  );
};
